import React from 'react';

import Banner from './Banner';
import HowWeWork from './HowWeWork';
import OurPhilosophy from './OurPhilosophy';
import Team from './Team';
import WhatWeDo from './WhatWeDo';
import WhoWeAre from './WhoWeAre';

const AboutUs:React.FC = () => (
  <>
    <Banner />
    <WhoWeAre />
    <WhatWeDo />
    <OurPhilosophy />
    <Team />
    <HowWeWork />
  </>
  );

export default AboutUs;
